module.exports = __webpack_public_path__ + "static/media/kamaz-00.6f284bda.png";